import { PayloadAction } from "@reduxjs/toolkit";
import {
  CartProductType,
  CartSliceState,
  CartType,
  DealerRemainsSortType,
  nomenclaturePath,
  ordersPath,
  remainsPath,
} from "../types";

export const uiReducers = {
  setProductionCartItems: (
    state: CartSliceState,
    action: PayloadAction<CartProductType[]>,
  ) => {
    state.productionItems = action.payload;
    const ids = action.payload?.reduce((acc, product) => {
      return (acc = [...acc, product.vendorId]);
    }, [] as string[]);
    state.allProdIds = ids;
  },
  setRemainsCartItems: (
    state: CartSliceState,
    action: PayloadAction<CartProductType[]>,
  ) => {
    state.remainsItems = action.payload;
  },
  setTotalProdPrice: (state: CartSliceState, action: PayloadAction<number>) => {
    state.totalProdPrice = action.payload;
  },
  setFrom: (
    state: CartSliceState,
    action: PayloadAction<
      typeof nomenclaturePath | typeof remainsPath | typeof ordersPath
    >,
  ) => {
    state.from = action.payload;
  },

  changeFilialsIdToShow: (
    state: CartSliceState,
    action: PayloadAction<{ id: string; type: CartType }>,
  ) => {
    const { id, type } = action.payload;
    const stateValue =
      type === "production"
        ? state.filalsProdIdsToShow
        : state.filalsRemainsIdsToShow;
    if (stateValue.includes(id)) {
      type === "production"
        ? (state.filalsProdIdsToShow = stateValue.filter((i) => i !== id))
        : (state.filalsRemainsIdsToShow = stateValue.filter((i) => i !== id));
    } else {
      type === "production"
        ? state.filalsProdIdsToShow.push(id)
        : state.filalsRemainsIdsToShow.push(id);
    }
  },

  changeAllFilialsId: (
    state: CartSliceState,
    action: PayloadAction<CartType>,
  ) => {
    const type = action.payload;
    if (type === "production") {
      state.filalsProdIdsToShow.length === state.allProdIds.length
        ? (state.filalsProdIdsToShow = [])
        : (state.filalsProdIdsToShow = state.allProdIds);
    } else {
      state.filalsRemainsIdsToShow.length === state.allRemainsIds.length
        ? (state.filalsRemainsIdsToShow = [])
        : (state.filalsRemainsIdsToShow = state.allRemainsIds);
    }
  },

  changeDealersIdToShow: (
    state: CartSliceState,
    action: PayloadAction<{ id: string; type: CartType }>,
  ) => {
    const { id, type } = action.payload;
    const stateValue =
      type === "production"
        ? state.dealersProdIdsToShow
        : state.dealersRemainsIdsToShow;
    if (stateValue.includes(id)) {
      type === "production"
        ? (state.dealersProdIdsToShow = stateValue.filter((i) => i !== id))
        : (state.dealersRemainsIdsToShow = stateValue.filter((i) => i !== id));
    } else {
      type === "production"
        ? state.dealersProdIdsToShow.push(id)
        : state.dealersRemainsIdsToShow.push(id);
    }
  },
  changeAllDealersId: (
    state: CartSliceState,
    action: PayloadAction<CartType>,
  ) => {
    const type = action.payload;
    if (type === "production") {
      state.dealersProdIdsToShow.length === state.allFilialsProdIds.length
        ? (state.dealersProdIdsToShow = [])
        : (state.dealersProdIdsToShow = state.allFilialsProdIds);
    } else {
      state.dealersRemainsIdsToShow.length === state.allFilialsRemainsIds.length
        ? (state.dealersRemainsIdsToShow = [])
        : (state.dealersRemainsIdsToShow = state.allFilialsRemainsIds);
    }
  },

  clearAllFilialsIds: (state: CartSliceState) => {
    state.filalsProdIdsToShow = [];
    state.filalsRemainsIdsToShow = [];
  },
  setCartLoader: (state: CartSliceState, action: PayloadAction<boolean>) => {
    state.isLoading = action.payload;
  },
  setCanCreateOrder: (
    state: CartSliceState,
    action: PayloadAction<boolean>,
  ) => {
    state.canCreateOrder = action.payload;
  },
  setDealerRemainsSort: (
    state: CartSliceState,
    action: PayloadAction<DealerRemainsSortType | null>,
  ) => {
    state.dealerRemainsSort = action.payload;
  },
  toggleDealerRemainsCollapsed: (
    state: CartSliceState,
    action: PayloadAction<string>,
  ) => {
    const id = action.payload;
    state.collapsedDealerRemainsIds = state.collapsedDealerRemainsIds.includes(
      id,
    )
      ? state.collapsedDealerRemainsIds.filter((i) => i !== id)
      : [...state.collapsedDealerRemainsIds, id];
  },
  setCollapsedDealerRemainsIds: (
    state: CartSliceState,
    action: PayloadAction<string[]>,
  ) => {
    state.collapsedDealerRemainsIds = action.payload;
  },
};
